import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { LOGIN_AUTH } from './types';
import { notify } from '../services/notification'

//User List GET API 

export const UserNameListAction = (page,page_size, role_id, admin_user_name) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.USER_NAMES_LIST + `?page_size=${page_size}&page=${page}`+(role_id ? "&role_id=" + role_id : "")+(admin_user_name ? "&user_name=" + admin_user_name : "") 
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(response => {
    if (response.status === 200) {
      dispatch({ type: types.GET_USER_NAME_LIST, payload: response })
      return response
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

export const UserNameAction = (id) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.USER_NAMES + "/" + id
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(response => {
    if (response.status === 200) {
      dispatch({ type: types.GET_USER_NAME, payload: response })
      return response
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

export const CreateUserAction = (params = {}) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.CREATE_USER
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      return resp
    } else { return null }
  }).catch(error => {
    if (error.response?.status === 400) {
      const data = error.response?.data;
      const errors = data?.errors;
      if (errors && typeof errors === 'object' && !Array.isArray(errors)) {
        // Field-level errors: show a toast per field
        Object.values(errors).forEach(msgs => {
          const msg = Array.isArray(msgs) ? msgs[0] : msgs;
          if (msg) notify.error(String(msg));
        });
      } else {
        const message = data?.message || data?.error || data?.detail || 'Failed to create user. Please check the details and try again.';
        notify.error(message);
      }
      return error.response;
    } else {
      errorHandler(error);
    }
  })
}

//Update Role PUT API 
export const UpdateUserAction = (params = {}, id) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.UPDATE_USER + "/" + id;
  let options = Object.assign({ method: 'PUT' }, params ? { data: params } : null);
  options.headers = getHeaders();
  options.url = url;
  
  return axios(options)
    .then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        return resp;
      } else {
        return null;
      }
    })
    .catch(error => {
      if (error.response && error.response.status === 400) {
        const responseData = error.response.data;
        if (responseData.error) {
          notify.error(responseData.error);
        }
        if (responseData.errors && responseData.errors.email) {
          notify.error(responseData.errors.email);
        }
        if (responseData.errors && responseData.errors.mobile_number) {
          notify.error(responseData.errors.mobile_number[0]);
        }
        // Return the full error response object
        return error.response;
      }
      errorHandler(error);
      // Return the full error response object
      return error.response; 
    });
};